/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
	const swVersion = process.env.VUE_APP_VERSION || '0.0.0'
	const swUrl = `${process.env.BASE_URL}service-worker.js?v=${encodeURIComponent(swVersion)}`

	register(swUrl, {
		ready () {
			console.log('[SW] Sirviendo desde cache.')
		},
		registered (registration) {
			console.log('[SW] Registrado.')
			// Chequear actualizaciones cada 5 minutos
			setInterval(() => {
				registration.update()
			}, 5 * 60 * 1000)
		},
		cached () {
			console.log('[SW] Contenido almacenado en cache para uso offline.')
		},
		updatefound () {
			console.log('[SW] Descargando nueva version...')
		},
		updated (registration) {
			console.log('[SW] Nueva version disponible.')
			document.dispatchEvent(
				new CustomEvent('swUpdated', { detail: registration })
			)
		},
		offline () {
			console.log('[SW] Sin conexion. App en modo offline.')
		},
		error (error) {
			console.error('[SW] Error en registro:', error)
		}
	})

	// Recargar con query param cuando cambie el controlador activo
	let refreshing = false
	navigator.serviceWorker.addEventListener('controllerchange', () => {
		if (refreshing) return
		refreshing = true
		const url = new URL(window.location.href)
		url.searchParams.set('v', String(Date.now()))
		window.location.href = url.toString()
	})

	// Recibir mensajes del SW (para debug y version activa)
	navigator.serviceWorker.addEventListener('message', (event) => {
		if (event.data && event.data.type === 'SW_VERSION') {
			console.log('[SW] Version activa en cache:', event.data.versionCache)
		}
	})
}
